import React, { useEffect, useState } from 'react';
import { Pagination } from 'react-bootstrap';
import { DEFAULT_PAGE, MAX_VISIBLE_PAGES } from '../../../constants/pagination';

interface TablePaginationProps {
  totalPages: number;
  onPageChange: (page: number) => void;
  ref?: React.Ref<HTMLDivElement>;
}

const TablePagination = ({
  totalPages,
  onPageChange,
  ref,
}: TablePaginationProps) => {
  // 選択されているページ番号
  const [activePage, setActivePage] = useState(DEFAULT_PAGE);
  // 一度に表示するページ数
  let maxVisible = MAX_VISIBLE_PAGES;

  useEffect(() => {
    setActivePage(DEFAULT_PAGE);
  }, [totalPages]);

  const handleClick = (page: number) => {
    setActivePage(page);
    onPageChange(page);
  };

  const handlePrev = () => {
    if (activePage > 1) {
      handleClick(activePage - 1);
    }
  };

  const handleNext = () => {
    if (activePage < totalPages) {
      handleClick(activePage + 1);
    }
  };

  // 表示するページ番号の先頭を計算（activePageを真ん中にする）
  // maxVisible=5なので真ん中は2つ前
  let startPage = activePage - 2;
  // 表示するページの先頭が1か2の場合は1を先頭にする
  if (startPage < 1) {
    startPage = 1;
  }

  // 表示の最後を必ずtotalPagesで終わるように調整
  if (startPage + maxVisible - 1 > totalPages) {
    startPage = totalPages - maxVisible + 1;

    if (startPage < 1) {
      startPage = 1;
    }
  }

  if (maxVisible > totalPages) {
    maxVisible = totalPages;
  }

  // 表示するページ番号の配列を生成
  const visiblePages = [];
  for (let i = startPage; i < startPage + maxVisible; i++) {
    visiblePages.push(i);
  }

  return (
    <div ref={ref}>
      <Pagination className="mt-4">
        <Pagination.Prev
          className="mx-1"
          onClick={handlePrev}
          disabled={activePage === 1}
        />

        {visiblePages.map((page) => (
          <Pagination.Item
            key={page}
            className="mx-1"
            active={page === activePage}
            onClick={() => handleClick(page)}
          >
            {page}
          </Pagination.Item>
        ))}

        <Pagination.Next
          className="mx-1"
          onClick={handleNext}
          disabled={activePage === totalPages}
        />
      </Pagination>
      <p className="text-center fs-6">
        {activePage} / {totalPages === 0 ? 1 : totalPages} ページ
      </p>
    </div>
  );
};

export default TablePagination;
